import { episodeAgainstChartsFrom } from '../episode/chartMovedAt';
import { CHARTS_FROM_LABEL } from '../episode/takeOverCopy';
import {
  formatDateToMMDDYYYY,
  parseISOToLocalDate,
} from '../../utils/dateUtils';

export { CHARTS_FROM_LABEL };

/** Calendar legend for the bar on the charting day (EMR-2976). */
export const START_OF_ROGER_CHARTING_LEGEND = 'Start of Roger charting';

/** Shared by the calendar bar, its legend swatch, and the task-table divider. */
export const ROGER_CHARTING_BAR_CLASS = 'bg-orange-500';

export type ChartsFromEpisode = {
  start_date: string;
  end_date: string;
  roger_charts_from: string | null | undefined;
};

/** Episode Manager cutoff markers apply only when the period straddles the day. */
export function episodeShowsChartsFromCutoff(
  episode: ChartsFromEpisode | null | undefined
): boolean {
  if (!episode?.roger_charts_from) return false;
  return episodeAgainstChartsFrom(episode) === 'contains';
}

/** Compact patient-header line (EMR-2976). */
export function patientHeaderChartsFromLine(dayIso: string): string {
  const formatted = formatDateToMMDDYYYY(dayIso);
  return formatted ? `${CHARTS_FROM_LABEL} ${formatted}` : CHARTS_FROM_LABEL;
}

const isSameCalendarDay = (left: Date, right: Date): boolean =>
  left.getFullYear() === right.getFullYear() &&
  left.getMonth() === right.getMonth() &&
  left.getDate() === right.getDate();

export function isBeforeRogerChartsFromDay(
  date: Date,
  chartsFromIso: string
): boolean {
  const chartsFrom = parseISOToLocalDate(chartsFromIso);
  if (!chartsFrom) return false;
  return date < chartsFrom && !isSameCalendarDay(date, chartsFrom);
}

export function isRogerChartsFromDay(
  date: Date,
  chartsFromIso: string
): boolean {
  const chartsFrom = parseISOToLocalDate(chartsFromIso);
  return chartsFrom ? isSameCalendarDay(date, chartsFrom) : false;
}

/** In-episode external days. Outside-episode inline style clears this image. */
export const CALENDAR_EXTERNAL_CHARTING_DAY_CLASS = 'external-emr-hatch';

export const CHARTS_FROM_BOUNDARY_DAY_CLASS =
  "relative after:pointer-events-none after:absolute after:left-1 after:top-1/2 after:z-30 after:h-[85%] after:w-[3px] after:-translate-y-1/2 after:rounded-full after:bg-orange-500 after:content-['']";
